import React, { useMemo } from 'react';
import { MediaType, ThemeContext, ViewerProperties, ViewerPropertiesComplete } from './model';
import {
  Media3D,
  MediaAudio,
  MediaIFrame,
  MediaImage,
  MediaImageVector,
  MediaUnknown,
  MediaVideo,
  MediaTGA,
  MediaText,
} from './viewers';
import { MediaWrapper } from './viewers/common/layer/MediaWrapper';

import './fileViewer.scss';
import { MediaCompressed } from './viewers/MediaCompressed';

// Spine-рантаймы тяжёлые: просмотрщик грузится отдельным чанком только при выборе Spine.
// Поэтому MediaSpine не экспортируется из viewers/index.ts (MYUA-17117).
const MediaSpine = React.lazy(() =>
  import('./viewers/MediaSpine').then((m) => ({ default: m.MediaSpine })),
);

const viewerPropertiesDefaults = (vp: ViewerProperties): ViewerPropertiesComplete => {
  return {
    captureMode: false,
    attachEventsToDocument: false,
    invert: false,
    compact: false,
    autoPlay: false,
    muted: false,
    ...vp,
  };
};
export const Media: React.FC<ViewerProperties> = (props) => {
  const propsDefault = viewerPropertiesDefaults(props);
  const media = useMemo(() => {
    if (propsDefault.type === MediaType.Asset3D) return <Media3D {...propsDefault} />;
    if (propsDefault.type === MediaType.Audio) return <MediaAudio {...propsDefault} />;
    if (propsDefault.type === MediaType.IFrame) return <MediaIFrame {...propsDefault} />;
    if (propsDefault.type === MediaType.Image) return <MediaImage {...propsDefault} />;
    if (propsDefault.type === MediaType.ImageVector) return <MediaImageVector {...propsDefault} />;
    if (propsDefault.type === MediaType.Video) return <MediaVideo {...propsDefault} />;
    if (propsDefault.type === MediaType.ImageTGA) return <MediaTGA {...propsDefault} />;
    if (propsDefault.type === MediaType.Text) return <MediaText {...propsDefault} />;
    if (propsDefault.type === MediaType.Docx) return <MediaText {...propsDefault} />;
    if (propsDefault.type === MediaType.Compressed) {
      // zip in creative navigator is not showing correctly
      if (!propsDefault.compressedFileTreeProvider) {
        return <MediaUnknown {...propsDefault} />;
      }
      return <MediaCompressed {...propsDefault} />;
    }
    if (propsDefault.type === MediaType.Spine) {
      return (
        <React.Suspense
          fallback={
            <span className="MediaText" data-preview-state="loading" data-preview-type="spine">
              loading
            </span>
          }
        >
          <MediaSpine {...propsDefault} />
        </React.Suspense>
      );
    }
    propsDefault.type satisfies MediaType.UNKNOWN;
    return <MediaUnknown {...propsDefault} />;
  }, [propsDefault]);

  return (
    <ThemeContext.Provider value={{ invert: propsDefault.invert }}>
      <div className={`gen-file-viewer__media invert-${propsDefault.invert}`}>
        {props.layerTool ? <MediaWrapper layerTool={props.layerTool}>{media}</MediaWrapper> : media}
      </div>
    </ThemeContext.Provider>
  );
};
